import { useEffect, useState } from 'react';

import { NotDataIcon } from '../../../../../../assets/svg/payment-links-custom/NotDataIcon';
import { ETPayEmptyBodyProps } from '../../../../../../models/table';
import {
	ContainerText,
	EmptyBodyTable,
	EmptyBodyTableSecondText,
	EmptyBodyTableText,
} from './styles';

const ETPayEmptyBody = <Entity,>({
	data,
	isLoading,
	filters,
	emptyMessage,
	emptySecondMessage,
}: ETPayEmptyBodyProps<Entity>) => {
	const [message, setMessage] = useState('');

	useEffect(() => {
		if (filters?.dateRange?.from && filters?.dateRange?.to && !!filters?.search) {
			setMessage('No se han encontrado resultados');
		} else if (filters?.dateRange?.from || filters?.dateRange?.to) {
			setMessage('No se han encontrado resultados para el rango de fechas seleccionado');
		} else if (filters?.search) {
			setMessage('No se han encontrado resultados para tu búsqueda');
		} else {
			setMessage(emptyMessage || 'No se han encontrado pagos');
		}
	}, [data]);

	return data.length === 0 && !isLoading ? (
		<EmptyBodyTable>
			<NotDataIcon />
			<ContainerText>
				<EmptyBodyTableText>{message}</EmptyBodyTableText>
				<EmptyBodyTableSecondText>
					{emptySecondMessage || 'En las últimas 24 horas no se realizó ningún pago.'}
				</EmptyBodyTableSecondText>
			</ContainerText>
		</EmptyBodyTable>
	) : null;
};

export { ETPayEmptyBody };
